import React, { ChangeEvent } from 'react';
import { useField } from 'formik';
import { useSelector } from 'react-redux';
import { FormControl, FormHelperText, Select } from '@material-ui/core';
import { IFormFieldProps } from 'shared/components/formFields/models';
import { IFormSelect } from 'shared/components/selects/model';
import { QuantityTypeLabelMap } from 'shared/models/sheet/Sheet';
import { useFormHelperTextStyles } from 'shared/styles/formHelperText';
import { IActivity } from 'store/entities/configuration/configurationModel';
import {
    selectActivitiesByIdWithoutDeleted, selectDefaultTimeActivities,
    selectTimeActivities,
} from 'store/entities/configuration/configurationSelectors';
import { makeHighPriorityStyles } from 'utils/stylesWrapper';

interface ITimeActivitySelectProps extends IFormFieldProps, IFormSelect {
    onlyDefaultActivities?: boolean;
}
const useStyles = makeHighPriorityStyles({
    multilineSelectInput: {
        paddingRight: '0 !important',
    },
});

export const TimeActivitySelect = ({
    name,
    outerLabel,
    className,
    title,
    onlyDefaultActivities = false,
    disabled = false,
    id = name,
}: ITimeActivitySelectProps) => {
    const classes = useStyles();
    const formHelperTextClasses = useFormHelperTextStyles();
    const [field, meta, helpers] = useField(name);
    const hasError = Boolean(meta.error && meta.touched);
    const activitiesById = useSelector(selectActivitiesByIdWithoutDeleted);
    const allTimeActivities = useSelector(selectTimeActivities);
    const defaultTimeActivities = useSelector(selectDefaultTimeActivities);
    const timeActivities = onlyDefaultActivities
        ? defaultTimeActivities
        : allTimeActivities;
    const handleChangeMultiple = (event: ChangeEvent<HTMLSelectElement>) => {
        const { options } = event.target as HTMLSelectElement;
        const value: IActivity[] = [...options]
            .filter(option => option.selected)
            .map(option => activitiesById[option.value]);
        helpers.setValue(value);
    };

    return (
        <FormControl
            variant="outlined"
            classes={{ root: className }}
            error={hasError}
        >
            {outerLabel && (
                <label
                    htmlFor={id}
                    className={formHelperTextClasses.outerLabel}
                    title={title}
                >
                    {outerLabel}
                </label>
            )}
            <Select
                multiple
                native
                value={field.value.map((item: IActivity) => item?.id)}
                // @ts-ignore
                onChange={handleChangeMultiple}
                inputProps={{
                    id,
                }}
                classes={{
                    select: classes.multilineSelectInput,
                }}
                disabled={disabled}
                title={title}
            >
                {timeActivities.map(activity => (
                    <option key={activity.id} value={activity.id}>
                        {activity.description} ({QuantityTypeLabelMap[activity.data_type]})
                    </option>
                ))}
            </Select>
            {hasError && (
                <FormHelperText classes={formHelperTextClasses}>
                    {meta.error}
                </FormHelperText>
            )}
        </FormControl>
    );
};
